import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getApiData } from "../helpers/AxiosInstance";

interface Props {
  queryKey: string[];
  url: string;
  params?: Record<string, string | number | boolean>;
}

const useGetHook = <T extends any>({ queryKey, url, params = null }: Props) => {
  const { isLoading, isError, data, isSuccess, refetch } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      const response = await getApiData(url, params);
      return response.data;
    },
    refetchOnWindowFocus: true,
  });
  return { isLoading, isError, data, isSuccess, refetch };
};

export default useGetHook;
